// coord-frontend/src/components/conversation/StickyInputBar.js
import React from "react";

// Floating input block shared by ConversationView and NewConversation:
// sticky within #main-scroll-container (the container provides the sidebar
// offset), content slides under the fade strip and behind the solid
// bg-background section, which also covers the home-indicator area via
// safe-bottom. Pages using this must render it as the last child of a
// `min-h-full flex flex-col -mb-4 md:-mb-8` column so the stuck and
// end-of-scroll positions coincide (see ConversationView.js).
const StickyInputBar = ({ children }) => (
  <div className="sticky bottom-0 z-10">
    <div className="h-6 bg-gradient-to-t from-background to-transparent" aria-hidden="true"></div>
    <div className="bg-background safe-bottom">
      <div className="w-full max-w-4xl mx-auto px-6 pb-3 md:pb-4">
        <div className="bg-background-card rounded-2xl p-4 shadow-sm border border-border-light">
          {children}
        </div>
        <p className="text-xs text-text-muted text-center mt-2 px-2">
          Coord bruker AI og kan gi unøyaktige svar. Dobbeltsjekk alltid viktig informasjon med Nav eller en fagperson.
        </p>
      </div>
    </div>
  </div>
);

export default StickyInputBar;
